import React from 'react';
import { colors } from '../../theme';

export const BouncingBalls: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{
        margin: 'auto',
        background: 'transparent',
        display: 'block',
      }}
      width="200px"
      height="100px"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle cx="35" cy="57.5" r="5" fill={colors.red2}>
        <animate
          attributeName="cy"
          calcMode="spline"
          keySplines="0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5"
          repeatCount="indefinite"
          values="57.5;42.5;57.5;57.5"
          keyTimes="0;0.3;0.6;1"
          dur="1s"
          begin="-0.6s"
        ></animate>
      </circle>
      <circle cx="50" cy="57.5" r="5" fill={colors.yellow2}>
        <animate
          attributeName="cy"
          calcMode="spline"
          keySplines="0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5"
          repeatCount="indefinite"
          values="57.5;42.5;57.5;57.5"
          keyTimes="0;0.3;0.6;1"
          dur="1s"
          begin="-0.4s"
        ></animate>
      </circle>
      <circle cx="65" cy="57.5" r="5" fill={colors.green2}>
        <animate
          attributeName="cy"
          calcMode="spline"
          keySplines="0 0.5 0.5 1;0.5 0 1 0.5;0.5 0.5 0.5 0.5"
          repeatCount="indefinite"
          values="57.5;42.5;57.5;57.5"
          keyTimes="0;0.3;0.6;1"
          dur="1s"
          begin="-0.2s"
        ></animate>
      </circle>
    </svg>
  );
};
